export const getFilterList = (originList) => {
  const filterList = []
  for (let n = 0; n < originList.length; n++) {
    filterList.push({ text: originList[n], value: originList[n] })
  }
  return filterList
}
